import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Col,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { staticConfig } from "../glAndAccounting.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const EditGLAccount = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newGLItems, statusData } = appStatic;

  const { state } = useLocation();

  const [accountTypeData, setAccountTypeData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [accountUsageData, setAccountUsageData] = useState([]);
  const [accountTagData, setAccountTagData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [manualEntriesAllowed, setManualEntriesAllowed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [glDetail, setGlDetail] = useState([]);
  const [glAccTemplate, setGlAccTemplate] = useState({});
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [glCodeLengthLoading, setGlCodeLengthLoading] = useState(false);
  const [glCodeLength, setGlCodeLength] = useState(1);

  // Watch the account type field for changes
  const selectedAccountType = Form.useWatch("type", form);

  useEffect(() => {
    getTemplate();
    getDetailById(state);
    getGlcodeLength();
  }, []);

  // Effect to handle account type changes and update parent/tag data
  useEffect(() => {
    if (selectedAccountType && glAccTemplate && initialDataLoaded) {
      updateParentAndTagData(selectedAccountType);
      // Only clear fields if this is not the initial load
      if (!isInitialLoad) {
        form.setFieldsValue({
          parentId: undefined,
          tagId: undefined,
        });
      }
    }
  }, [selectedAccountType, glAccTemplate, initialDataLoaded, isInitialLoad]);

  const updateParentAndTagData = (accountTypeId) => {
    // Find the account type option to get its label
    const accountTypeOption = accountTypeData.find(
      (option) => option.value === accountTypeId
    );

    if (!accountTypeOption) return;

    const accountTypeLabel = accountTypeOption.label.toLowerCase();
    console.log(accountTypeLabel);

    let parentOptions = [];
    let tagOptions = [];

    switch (accountTypeLabel) {
      case "asset":
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;

      case "liability":
        parentOptions = getOptionsFromTemplate("liabilityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedLiabilitiesTagOptions");
        break;

      case "equity":
        parentOptions = getOptionsFromTemplate("equityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedEquityTagOptions");
        break;

      case "expense":
        parentOptions = getOptionsFromTemplate("expenseHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedExpensesTagOptions");
        break;

      case "income":
        parentOptions = getOptionsFromTemplate("incomeHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedIncomeTagOptions");
        break;

      case "contingent_asset":
        parentOptions = getOptionsFromTemplate(
          "contingentAssetHeaderAccountOptions"
        );
        tagOptions = getOptionsFromTemplate(
          "allowedContingentAssetsTagOptions"
        );
        break;

      case "contingent_liability":
        parentOptions = getOptionsFromTemplate(
          "contingentLiabilityHeaderAccountOptions"
        );
        tagOptions = getOptionsFromTemplate(
          "allowedContingentLiabilitiesTagOptions"
        );
        break;

      default:
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;
    }

    setParentData(parentOptions);
    setAccountTagData(tagOptions);
  };

  const getOptionsFromTemplate = (templateKey) => {
    console.log(templateKey, "templateKey");
    if (!glAccTemplate[templateKey]) return [];

    return glAccTemplate[templateKey].map((element) => ({
      value: element.id,
      label: element.name,
    }));
  };

  function onCancel() {
    navigate("/gla0100", { replace: false });
  }

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.GlAccount}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setGlDetail(objDetail);

        // SHOW THE SAVED DATA
        form.setFieldsValue({
          name: objDetail.name,
          glCode: objDetail.glCode,
          type: objDetail?.type?.id,
          parentId: objDetail?.parentId,
          usage: objDetail?.usage?.id,
          tagId: objDetail?.tagId?.id === 0 ? undefined : objDetail?.tagId?.id,
          status: objDetail?.status,
          currencyCode: objDetail?.currencyCode,
          description: objDetail?.description,
          manualEntriesAllowed: objDetail?.manualEntriesAllowed,
        });
        setManualEntriesAllowed(objDetail?.manualEntriesAllowed);
        setInitialDataLoaded(true);
        setIsLoading(false);
      }
    });
  };

  function getTemplate() {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GlAccountTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        setGlAccTemplate(res);

        let tempAccountType = [];
        let tempAccountUsage = [];
        let tempCurrency = [];

        objList?.accountTypeOptions?.forEach((element) => {
          tempAccountType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.usageOptions?.forEach((element) => {
          tempAccountUsage.push({
            value: element.id,
            label: element.value,
          });
        });
        // Add "All" option first, then add other currencies
        tempCurrency.push({
          value: "ALL",
          label: "All Currencies",
        });
        objList?.currencies?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        setAccountTypeData(tempAccountType);
        setAccountUsageData(tempAccountUsage);
        setCurrencyData(tempCurrency);
      }
    });
  }
  function getGlcodeLength() {
    setGlCodeLengthLoading(true);
    let body = {
      session,
    };

    BOM.FetchReqAction(
      body,
      definedApi.GlAccountCodeLengthConfig,
      (err, res) => {
        setGlCodeLengthLoading(false);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err);
        } else {
          console.log(res);
          setGlCodeLength(res?.value ?? 0);
        }
      }
    );
  }

  const handleManuelEntriesAllowed = (keyParam) => {
    setManualEntriesAllowed(keyParam);
  };

  const handleAccTypeChange = (value, option) => {
    // Set isInitialLoad to false when user manually changes account type
    if (isInitialLoad) {
      setIsInitialLoad(false);
    }
  };
  const handleCurrencyChange = (value) => {
    setSelectedCurrency(value);
  };

  const onSubmit = (formValues) => {
    // Remove currencyCode from payload if "All" is selected
    if (selectedCurrency === "ALL" || formValues.currencyCode === "ALL") {
      delete formValues.currencyCode;
    }
    const url = `${definedApi.GlAccount}/${state.key}`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.editGLCreatedMsg);
          navigate("/gla0100");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0100");
          setIsLoading(false);
        },
      }
    );
  };

  console.log(parentData);
  return (
    <MainLayout isEnableRightSidebar={false}>
      <TopContent
        pageTitle={appLabel.editGLAccount}
        pageItems={appStatic.editGLItems}
      />
      <Spin spinning={isLoading || glCodeLengthLoading} size="large">
        <Card
          title={
            <Title level={4} style={{ color: "#000" }}>
              {appLabel.generalInfo}
            </Title>
          }
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Card
              style={{
                marginBottom: "3%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
              bordered
            >
              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="type"
                    label={<Text strong>{appLabel.accountType}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.accountType),
                      },
                    ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountType
                      )}
                      showSearch
                      options={accountTypeData}
                      onChange={handleAccTypeChange}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="parentId"
                    label={<Text strong>{appLabel.parent}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.parent),
                      },
                    ]}
                  >
                    <Select
                      // placeholder={BOM.handlePlaceholderMsg(appLabel.parent)}
                      showSearch
                      options={parentData}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      allowClear
                      key={selectedAccountType} // Force re-render when account type changes
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="glCode"
                    label={<Text strong>{appLabel.GLCode}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.GLCode),
                      },
                      {
                        min: glCodeLength,
                        max: glCodeLength,
                        message: `GL Code must be ${glCodeLength} characters long`,
                      },
                    ]}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(appLabel.GLCode)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="name"
                    label={<Text strong>{appLabel.accountName}</Text>}
                    rules={[
                      {
                        required: true,
                        message: BOM.CheckReqFld(appLabel.accountName),
                      },
                    ]}
                  >
                    <Input
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountName
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="usage"
                    label={<Text strong>{appLabel.accountUsage}</Text>}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: BOM.CheckReqFld(appLabel.accountUsage),
                    //   },
                    // ]}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.accountUsage
                      )}
                      showSearch
                      options={accountUsageData}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="tagId"
                    label={<Text strong>{appLabel.tag}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.tag)}
                      showSearch
                      options={accountTagData}
                      key={selectedAccountType} // Force re-render when account type changes
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="manualEntriesAllowed"
                    label={<Text strong>{appLabel.manualEntriesAllowed}</Text>}
                  >
                    <Select
                      options={staticConfig.yesOrNo}
                      placeholder={BOM.handlePlaceholderMsg(
                        appLabel.manualEntriesAllowed
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="status"
                    label={<Text strong>{appLabel.status}</Text>}
                    //     rules={[
                    //   {
                    //     required: true,
                    //     message: "This field is required",
                    //   },
                    // ]}
                  >
                    <Select
                      options={statusData}
                      placeholder={BOM.handlePlaceholderMsg(appLabel.status)}
                    />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="currencyCode"
                    label={<Text strong>{appLabel.currency}</Text>}
                  >
                    <Select
                      placeholder={BOM.handlePlaceholderMsg(appLabel.currency)}
                      options={currencyData}
                      showSearch
                      allowClear
                      onChange={handleCurrencyChange}
                      filterOption={(input, option) =>
                        option?.label
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      optionRender={(option) => (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontWeight:
                              option.data.value === "ALL" ? "bold" : "normal",
                            color:
                              option.data.value === "ALL"
                                ? "#92428B"
                                : "inherit",
                          }}
                        >
                          <span>{option.data.label}</span>
                          {option.data.value === "ALL" && (
                            <span style={{ fontSize: "12px", color: "#999" }}>
                              (No currency restriction)
                            </span>
                          )}
                        </div>
                      )}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="description"
                    label={<Text strong>{appLabel.description}</Text>}
                    style={{ width: "100%" }}
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: BOM.CheckReqFld(appLabel.description),
                    //   },
                    // ]}
                  >
                    <TextArea
                      showCount
                      maxLength={1000}
                      placeholder="Enter Account description"
                      style={{
                        height: 120,
                        resize: "none",
                      }}
                    ></TextArea>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
            <Form.Item>
              <Row>
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
                <CustomButton
                  content="Cancel"
                  style={{
                    width: "10%",
                    marginLeft: "1%",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  backgroundColor="#fff"
                  colorText="black"
                  hoverBackground="#F5F5F5"
                  onClick={onCancel}
                />
              </Row>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditGLAccount);
